import { useState } from "react";

import { PublicationListData } from "@/components/business/PublicationListContainer/publicationList.types";
import { ProcessStatusCode } from "@/types/code.types";
import Modal from "@atoms/Modal/Modal";
import IconAlert from "@images/pressList/statusModal/icon-alert-red.svg";
import IconClose from "@images/pressList/statusModal/icon-close.svg";
import { DRAFT_STATUS_INFO } from "@PressListContainer/draftStatusInfo.constants";

import * as S from "./CheckStatusGuide.style";
import { useMovePublicationDetailPage } from "../../hooks/useMovePublicationDetailPage";

interface Props {
  publicationListData: PublicationListData[];
  draftArticleId: number;
  closeModal: () => void;
  updatePublicationList: () => void;
  currentStatus: ProcessStatusCode | "";
}

const ListCheckStatusGuide = ({
  publicationListData,
  closeModal,
  draftArticleId,
  updatePublicationList,
  currentStatus,
}: Props) => {
  const publicationData = publicationListData?.filter(
    (publication) => publication.publicationId === draftArticleId.toString(),
  )?.[0];

  const [initPressStatus] = useState(
    publicationData?.draftArticleStatusHighest,
  );

  const { movePublicationDetailPage } = useMovePublicationDetailPage({
    draftArticleId: publicationData?.publicationId?.toString(),
  });

  const handleCancelEvent = () => {
    updatePublicationList();
    closeModal();
  };

  return (
    <Modal closeModal={closeModal}>
      <S.ModalContentsWrapper>
        <S.ModalTitle>
          <img src={IconAlert} alt="" />
          Status Change Notification
        </S.ModalTitle>
        <S.ModalText>
          The status of the selected Press has been changed from ‘
          <strong>
            {initPressStatus && DRAFT_STATUS_INFO[initPressStatus].text}
          </strong>
          ’ to ‘
          <strong>
            {currentStatus && DRAFT_STATUS_INFO[currentStatus].text}
          </strong>
          ’. Would you like to continue?
        </S.ModalText>
        <S.ModalButtonWrapper>
          <S.CancelButton type="button" onClick={handleCancelEvent}>
            Back to Publication List
          </S.CancelButton>
          <S.RefreshButton type="button" onClick={movePublicationDetailPage}>
            Continue
          </S.RefreshButton>
          <S.CloseButton type="button" onClick={handleCancelEvent}>
            <img src={IconClose} alt="Close" />
          </S.CloseButton>
        </S.ModalButtonWrapper>
      </S.ModalContentsWrapper>
    </Modal>
  );
};

export default ListCheckStatusGuide;
